import { render, staticRenderFns } from "./u-tooltip-outlined-pill.vue?vue&type=template&id=5c0914da&scoped=true&"
import script from "./u-tooltip-outlined-pill.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-outlined-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0914da",
  null
  
)

export default component.exports